let baseUrl = $('meta[name="base-url"]').attr('content');
let csrfToken = $('meta[name="csrf-token"]').attr('content');

const formOptions = {
    noAlerts: true
};

// Set the local server path for Formio.js libraries
Formio.setBaseUrl(baseUrl); // Replace with your local server URL
Formio.setApiUrl(baseUrl); // Replace with your local server URL
Formio.setProjectUrl(baseUrl + '/form-submission');
Formio.icons = 'fontawesome';


Formio.createForm(document.getElementById('formio'), formDefinition, formOptions).then(function (form) {
    form.submission = {
        data: formData,
    };

    form.nosubmit = true;

    let previousPageIndex = 0;
    let lastVisitedPage = 0;
    if (formDefinition && formDefinition.display && formDefinition.display === 'wizard') {
        if (form && form.pages && form.pages.length) {
            let isPageValid = false;
            for (let i = 0; i < form.pages.length; i++) {
                const currentPage = form.pages[i];
                let pageFlagName = 'savedPage' + i;
                isPageValid = (formData && formData[pageFlagName]) ? formData[pageFlagName] : false;
                lastVisitedPage = i;
                if (isPageValid !== true) {
                    break; // No need to check further, at least one page is not valid
                }
            }
            form.setPage(lastVisitedPage);
        }
    }

    form.on('wizardPageSelected', function (event) {
        const currentPageIndex = form.page; // Get the current page index

        // Check if the user is moving forward or backward
        const isMovingForward = currentPageIndex > previousPageIndex;

        let errorPageIndex = -1;
        if (isMovingForward) {
            // Check the validity of all pages
            let allPagesValid = true;
            for (let i = previousPageIndex; i < currentPageIndex; i++) {
                const currentPage = form.pages[i];
                const isPageValid = currentPage && currentPage.checkValidity(true, true, true);
                if (!isPageValid) {
                    allPagesValid = false;
                    errorPageIndex = i;
                    break; // No need to check further, at least one page is not valid
                }
            }
            if ((errorPageIndex >= 0) && (allPagesValid === false)) {
                Swal.fire({
                    title: 'Please fill all fields before proceeding.',
                    icon: 'info',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: '<i class="fa fa-info-circle"></i> Yes, I will fill them out!',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                }).then((result) => {
                    if (result.value) {
                        form.setPage(errorPageIndex);
                        // Update the previous page index for the next event
                        previousPageIndex = errorPageIndex;
                        errorPageIndex = -1;
                    }
                });
            }
        } else {
            // Update the previous page index for the next event
            previousPageIndex = currentPageIndex;
        }
    });

    // Register the 'saveBeforeNextPage' event handler
    form.on('saveBeforeNextPage', (nextPage) => {

        // Capture the current page index
        const currentPageIndex = form.page;

        if (currentPageIndex >= 0) {
            form.submission.data['savedPage' + currentPageIndex] = true;
        }

        // Save the form data (you can replace this with your own implementation)
        saveFormData(form, 'nextPage')
            .then(() => {
                // Continue to the next page
                form.nextPage();
            })
            .catch(error => {
                // Handle any errors during the saving process
                console.error('Error saving form data:', error);
            });
    });

    // Register the 'saveBeforePreviousPage' event handler
    form.on('saveBeforePreviousPage', (previousPage) => {
        // Get the form data
        const formData = form.submission;
        const currentPage = form.page;

        // Save the form data (you can replace this with your own implementation)
        saveFormData(form, 'previousPage')
            .then(() => {
                // Continue to the previous page
                // Go to the previous page only if it's not the first page
                if (currentPage > 0) {
                    // Go to the previous page
                    form.setPage(currentPage - 1);
                }
            })
            .catch(error => {
                // Handle any errors during the saving process
                console.error('Error saving form data:', error);
            });
    });

    // Event listener for the 'nextPage' event
    form.on('nextPage', () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        $('.btn-wizard-nav-submit').length ? $('.btn-wizard-nav-submit').addClass('d-none') : null;
    });


    form.on('change', (event) => {
        try {
            
            const changedComponent = event.changed && event.changed.component ? event.changed.component : null;
            const changedComponentInstance = event.changed && event.changed.instance ? event.changed.instance : null;
            const data = event.data ? event.data : null;
            const changedComponentKey = changedComponent && changedComponent.key ? changedComponent.key : '';
            let verifiedFieldValue = data[changedComponentKey + 'Verified'] ? data[changedComponentKey + 'Verified'] : '';
            let errorValidationCheck = true;
            // Perform actions based on the changed component and its new value

            //Disable the verify link 
            let verifyLinkID = 'verify-email-id';
            if(changedComponentKey === 'alternateEmailId') {
                verifyLinkID = 'verify-alternate-email-id';
            } else if(changedComponentKey === 'mobileNumber') {
                verifyLinkID = 'verify-mobile-no';
            }
            
            if (changedComponent && (changedComponentKey === 'aadhaarNumber' || changedComponentKey === 'emailId' || changedComponentKey === 'alternateEmailId' || changedComponentKey === 'mobileNumber')) {
                // Check the same value entered in another field
                errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;
                if (errorValidationCheck) {
                    if (changedComponentKey === 'emailId' || changedComponentKey === 'alternateEmailId') {
                        let emailIdComponent = form.getComponent('emailId');
                        let alternateEmailIdComponent = form.getComponent('alternateEmailId');
                        let currentComponent = form.getComponent(changedComponentKey);

                        if (emailIdComponent && alternateEmailIdComponent) {

                            let emailIdVal = form.submission.data['emailId'] ? form.submission.data['emailId'] : '';
                            let alternateEmailIdVal = form.submission.data['alternateEmailId'] ? form.submission.data['alternateEmailId'] : '';

                            if (emailIdVal != '' && alternateEmailIdVal != '' && (emailIdVal === alternateEmailIdVal)) {
                                let errorMessage = currentComponent.t('{{ emailIdErrorLabel }} and {{ alternateEmailIdErrorLabel }} should not be the same.', {
                                    emailIdErrorLabel: emailIdComponent.errorLabel,
                                    alternateEmailIdErrorLabel: alternateEmailIdComponent.errorLabel,
                                    data: currentComponent.data
                                });
                                currentComponent.setCustomValidity(errorMessage);
                                currentComponent.invalid = true;
                                // Focus on the input field with the dynamic name attribute
                                $("#" + verifyLinkID).hasClass("disabled disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled disabled-link");
                                $('[name="data[' + changedComponentKey + ']"]').focus();
                            }
                        }
                    }
                }

                // Unique value check with database
                errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;
                if (errorValidationCheck) {
                    let doYouWantUniqueCheck = formDefinition.doYouWantUniqueCheck ? formDefinition.doYouWantUniqueCheck : 'No';
                    let typeOfUniqueCheck = formDefinition.typeOfUniqueCheck ? formDefinition.typeOfUniqueCheck : '';

                    if (doYouWantUniqueCheck === 'Yes' && typeOfUniqueCheck === 'individual' && verifiedFieldValue !== 'Yes') {
                        customUniqueValidation(form, changedComponentKey).then(function (uniqueCheckResponse) {
                            if (uniqueCheckResponse === false) {
                                $("#" + verifyLinkID).hasClass("disabled disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled disabled-link");
                                const submitButton = form.getComponent('submit');
                                if (submitButton) {
                                    submitButton.loading = false;
                                    submitButton.disabled = false;

                                    // Refresh the button's appearance to remove the loader
                                    submitButton.redraw();

                                    form.emit('submitError', "error");
                                    return false;
                                }
                            }
                        });
                    }
                }

                // Field Verification Check, 
                errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;
                const newValue = data[changedComponentKey];
                if (errorValidationCheck) {
                    if (verifiedFieldValue === 'No') {
                        $("#" + verifyLinkID).hasClass("disabled-link") ? $("#" + verifyLinkID).removeClass("disabled-link") : '';

                        // Check the verification during field value change
                        let component = form.getComponent(changedComponentKey);
                        if (form.submission && form.submission.data[component.key] != '') {
                            verificationErrorLabel = component.t('Please verify the {{ field }}', {
                                field: component.errorLabel,
                                data: component.data
                            });
                            component.setCustomValidity(verificationErrorLabel);
                            component.invalid = true;
                            // Focus on the input field with the dynamic name attribute
                            $('[name="data[' + component.key + ']"]').focus();
                        }
                    } else {
                        $("#" + verifyLinkID).hasClass("disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled-link");
                    }
                } else {
                    $("#" + verifyLinkID).hasClass("disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled-link");
                }
            }

            // You can add your custom logic here, such as updating other components or performing calculations.
        } catch (error) {
            console.error('An error occurred:', error);
        }
    });

    // Triggered when they click the submit button.
    form.on('submit', function (submission) {
        submission.form_master_id = formMasterId;
        let submitFlag = true;

        checkProfileVerifications(form).then(function (checkResponse) {
            if (checkResponse === false) {
                let submitButton = form.getComponent('submit');
                if (submitButton) {
                    submitButton.loading = false;
                    submitButton.disabled = false;

                    // Refresh the button's appearance to remove the loader
                    submitButton.redraw();

                    form.emit('submitError', "error");
                    return false;
                }
            } else {
                customUniqueValidation(form).then(function (submitResponse) {
                    if (submitFlag == false) {
                        form.emit('submitError', "error");
                        return false;
                    }

                    const dateComponentKeys = ['appliedDate', 'dateOfBirth', 'expectedDateOfCompletion', 'offerDate', 'issuedDate', 'validUpto', 'sslcStartDate', 'sslcEndDate', 'hscStartDate', 'hscEndDate', 'diplomaStartDate', 'diplomaEndDate', 'ugStartDate', 'ugEndDate', 'pgStartDate', 'pgEndDate', 'issueDate', 'expiryDate', 'durationFrom', 'durationTo', 'durationFromEmployment', 'durationToEmployment', "durationTo"]; // Array of component keys for date fields

                    dateComponentKeys.forEach((componentKey) => {
                        const component = form.getComponent(componentKey);
                        if (component && component.type === 'datetime') {
                            const dateValue = form.submission.data[component.key];
                            const convertedDate = moment(dateValue, 'YYYY-MM-DD').format('DD-MMM-YYYY');
                            form.submission.data[component.key] = convertedDate;
                        }
                    });

                    if (submitResponse === false) {
                        const submitButton = form.getComponent('submit');
                        if (submitButton) {
                            submitButton.loading = false;
                            submitButton.disabled = false;

                            // Refresh the button's appearance to remove the loader
                            submitButton.redraw();

                            form.emit('submitError', "error");
                            return false;
                        }
                    } else {
                        let formData = form.submission;
                        saveFormData(form);
                    }
                });
            }
        });
    });

    // Mobile Number & Email Address OTP Verification
    var elementApiAttr = {
        'mobileNumber': 'mobile',
        'emailId': 'email',
        'alternateEmailId': 'email'
    };

    $(document).on('click', '#verify-mobile-no, #verify-email-id, #verify-alternate-email-id', function (event) {
        event.preventDefault();
        var eve = this;
        var eveId = $(eve).attr('id');
        let actionName = '';
        if (eveId == 'verify-mobile-no') {
            var inputElement = Object.keys(form.submission.data);
            inputElement = "mobileNumber";
            var inputVal = form.submission.data.mobileNumber;
        } else if (eveId == 'verify-alternate-email-id') {
            var inputElement = Object.keys(form.submission.data);
            inputElement = "alternateEmailId";
            var inputVal = form.submission.data.alternateEmailId;
        } else {
            var inputElement = Object.keys(form.submission.data);
            inputElement = "emailId";
            var inputVal = form.submission.data.emailId;
        }
        actionName = $(this).data('action') ? $(this).data('action') : '';
        generateOtp(inputElement, inputVal, eve, actionName);
    });

    var inputValue;
    var token = '';
    function generateOtp(inputElement, inputVal, eve, actionName = '') {
        let inputKey = elementApiAttr[inputElement];
        let inputName = $(eve).attr('data-parent');
        let inputId = $(eve).attr('id');
        let resendName = (inputKey == 'mobile') ? `<a href="#" id="${inputId}" class="float-right" style="font-size: 14px" data-action="re-generate"><u>Resend OTP</u></a>` : `<a href="#" id="${inputId}" class="float-right" style="font-size: 14px;" data-action="re-generate"><u>Resend Verification Code</u></a>`;
        let resendMsg = (inputKey == 'mobile') ? 'OTP resent successfully to your mobile number' : 'Verification code resent successfully to your ' + inputName;

        let data = {};
        inputValue = inputVal;
        data[inputKey] = inputVal;
        data['type'] = 'generate-otp';
        data['user_id'] = 1;

        if (inputKey == 'email')
            data['content'] = formDefinition.emailContentToBePublished;

        Swal.getValidationMessage() ? Swal.resetValidationMessage() : '';  // Reset the validation message
        $('#resend-success-alert').addClass('d-none');  // Reset the success alert

        $.ajax({
            url: otpServiceUrl + "generate-otp",
            method: "POST",
            data: data,
            success: function (response) {
                if (response.success) {
                    token = response.token;
                    if (actionName != 're-generate') {
                        Swal.fire({
                            title: "",
                            html: '<h4>OTP Verification</h4>' +
                                '<hr>' +
                                `<div class="alert alert-default-success d-none" id="resend-success-alert">${resendMsg}</div>` +
                                `<p>We have sent a verification code to the given ${inputName} <b>${data[inputKey]}</b>. Please enter the code here to verify.</p>` +
                                '<label for="verifyOTP" class="form-label mt-2">Verification Code</label>' +
                                '<input type="text" class="form-control" name="verifyOTP" id="verifyOTPVal" placeholder="______" data-slots="_" data-accept="\w" maxlength="6">' +
                                `${resendName}`,
                            showCloseButton: true,
                            allowOutsideClick: false,
                            showCancelButton: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            showLoaderOnConfirm: false,
                            confirmButtonText: 'Verify',
                            preConfirm: () => {
                                return new Promise(function (resolve, reject) {
                                    const otp = document.getElementById("verifyOTPVal").value;
                                    if (!otp) {
                                        Swal.showValidationMessage("Please enter your OTP!");
                                        reject();

                                        // Reset OTP input and enable verify button
                                        $('#verifyOTPVal').val('');
                                        $('.swal2-confirm').prop("disabled", false);
                                    } else if (!/^\d{6}$/.test(otp)) {
                                        Swal.showValidationMessage('Please enter a 6-digit numeric OTP');
                                        reject();

                                        // Reset OTP input and enable verify button
                                        $('#verifyOTPVal').val('');
                                        $('.swal2-confirm').prop("disabled", false);
                                    } else {
                                        let verifyInputElement = inputKey;
                                        let otp = document.getElementById('verifyOTPVal').value;

                                        let data = {};
                                        data['token'] = token;
                                        data['otp'] = otp;
                                        data[inputKey] = inputValue;

                                        $('#resend-success-alert').addClass('d-none'); // Reset the success alert

                                        // Perform the AJAX request
                                        $.ajax({
                                            url: otpServiceUrl + "validate-otp",
                                            method: "POST",
                                            data: data,
                                            success: function (response) {
                                                // let inputElementName = (verifyInputElement == 'mobile') ? 'data[mobileNumber]' : 'data[personalMailId]';
                                                let inputElementName = (verifyInputElement == 'mobile') ? `data[${inputElement}]` : `data[${inputElement}]`;
                                                if (response.success === true) {
                                                    $('input[name="' + inputElementName + '"]').prop("disabled", true);
                                                    $('a#' + inputId).prop("disabled", true);

                                                    $(eve).text('Verified').addClass('disabled disabled-link').parent('span.input-group-text').addClass('bg-green');
                                                    form.submission.data[inputElement + 'Verified'] = 'Yes';

                                                    let componentDefinition = form.getComponent(inputElement);
                                                    componentDefinition.setCustomValidity('');
                                                    componentDefinition.invalid = false;

                                                    let message = 'Your OTP has been verified successfully';
                                                    Swal.fire('Verified', message, 'success');
                                                    resolve();
                                                } else {
                                                    // Reset OTP input and enable verify button
                                                    $('#verifyOTPVal').val('');
                                                    $('.swal2-confirm').prop("disabled", false);
                                                    $('a#' + inputId).removeClass('disabled disabled-link');
                                                    Swal.showValidationMessage(response.message);
                                                    reject();
                                                }
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    } else {
                        if (actionName == 're-generate') {
                            $('div#resend-success-alert').removeClass('d-none');
                        }
                    }
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: response.message,
                        willClose: function () {
                            // Reset OTP input and enable verify button
                            $('#verifyOTPVal').val('');
                            $('.swal2-confirm').prop("disabled", false);
                            $('a#' + inputId).removeClass('disabled disabled-link');
                        }
                    });
                }
            }
        });
    }
});

// Function to calculate the full age, including days, based on the birthdate
function calculateFullAge(birthdate, ageondate) {
    if (birthdate !== undefined && birthdate !== '' && birthdate !== null) {
        var birthdateObj = new Date(birthdate);
        var currentDate = new Date(ageondate);
        var years = currentDate.getFullYear() - birthdateObj.getFullYear();
        var months = currentDate.getMonth() - birthdateObj.getMonth();
        var days = currentDate.getDate() - birthdateObj.getDate();

        if (months < 0 || (months === 0 && days < 0)) {
            years--;
            months += 12;
        }

        if (days < 0) {
            var prevMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
            days += prevMonthLastDay;
            months--;
        }
        return years + ' YEARS, ' + months + ' MONTHS, ' + days + ' DAYS';
    } else {
        return '';
    }
}

async function customUniqueValidation(form, individualComponentKey = '') {
    let uniqueComponents = [];
    let componentKey = '';
    let componentDefinition = {};
    let doYouWantUniqueCheck = formDefinition.doYouWantUniqueCheck ? formDefinition.doYouWantUniqueCheck : 'No';
    let typeOfUniqueCheck = formDefinition.typeOfUniqueCheck ? formDefinition.typeOfUniqueCheck : '';
    if (doYouWantUniqueCheck === 'Yes') {
        let uniqueFormData = [];
        let uniqueComponentKeys = [];
        let uniqueErrorLabel = 'Combination of ';
        if(typeOfUniqueCheck === 'combination') {
            if (formDataDefinition instanceof Array) {
                for (var prop in formDataDefinition) {
                    if (formDataDefinition[prop] && formDataDefinition[prop].unique === true) {
                        componentKey = formDataDefinition[prop].key ? formDataDefinition[prop].key : '';
                        if (componentKey != '' && form.submission && form.submission.data[componentKey] && form.submission.data[componentKey].trim() != '') {
                            componentDefinition = form.getComponent(componentKey);
                            uniqueComponents.push(componentDefinition);
                        }
                    }
                }
            }
    
            if (uniqueComponents.length) {
                uniqueComponents.forEach((component) => {
                    if (form.submission && form.submission.data[component.key] != '') {
                        uniqueFormData.push({ key: component.key, value: form.submission.data[component.key] });
                        uniqueComponentKeys.push({ key: component.key, label: component.label });
    
                        if (uniqueComponents.length == 1) {
                            uniqueErrorLabel = component.t(component.errorMessage('unique'), {
                                field: component.errorLabel,
                                data: component.data
                            });
                        } else {
                            uniqueErrorLabel += component.label + ', ';
                        }
                    }
                });
    
                if (uniqueComponents.length > 1) {
                    uniqueErrorLabel = uniqueErrorLabel.trim(', ');
    
                    let lastComma = uniqueErrorLabel.lastIndexOf(',');
                    uniqueErrorLabel = uniqueErrorLabel.substring(0, lastComma);
    
                    lastComma = uniqueErrorLabel.lastIndexOf(',');
                    uniqueErrorLabel = uniqueErrorLabel.substring(0, lastComma) + ' and' + uniqueErrorLabel.substring(lastComma + 1);
    
                    uniqueErrorLabel = uniqueErrorLabel + ' are already exists.';
                }
            }
        } else if(typeOfUniqueCheck === 'individual' && individualComponentKey != '') {
            let individualComponent = form.getComponent(individualComponentKey);
            uniqueComponents.push(individualComponent);

            if (individualComponent && form.submission && form.submission.data[individualComponent.key] != '') {
                uniqueFormData.push({ key: individualComponent.key, value: form.submission.data[individualComponent.key] });
                uniqueComponentKeys.push({ key: individualComponent.key, label: individualComponent.label });

                if (uniqueComponents.length == 1) {
                    uniqueErrorLabel = individualComponent.t(individualComponent.errorMessage('unique'), {
                        field: individualComponent.errorLabel,
                        data: individualComponent.data
                    });
                }
            }
        }

        if (uniqueFormData.length) {
            return new Promise(function (resolve, reject) {
                return fetch('/form-submissions/check-unique-data', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify({ uniqueFormData: uniqueFormData, form_master_id: formMasterId })
                }).then(response => {
                    return response.json();
                }).then(data => {
                    if (data.success) {
                        return resolve(true);
                    } else {
                        return resolve(false);
                    }
                });
            }).then(res => {
                if (!res) {
                    let message = uniqueErrorLabel;
                    if (uniqueComponentKeys.length) {
                        uniqueComponents.forEach((component) => {
                            component.setCustomValidity(message);
                            component.invalid = true;    
                            if(typeOfUniqueCheck === 'combination') {
                                let eve = '';
                                if (component.key === 'emailId') {
                                    eve = 'a#verify-email-id';
                                } else if (component.key === 'alternateEmailId') {
                                    eve = 'a#verify-alternate-email-id';
                                } else {
                                    eve = 'a#verify-mobile-no';
                                }
        
                                $('input[name="' + component.key + '"]').removeAttr("disabled");
                                $(eve).html('<u>Verify</u>').addClass('disabled disabled-link').parent('span.input-group-text').removeClass('bg-green');
                                form.submission.data[component.key + 'Verified'] = 'No';
                            }
                        });
                    }
                }
                return res;
            }).catch(error => {
                return false;
            });
        } else {
            return true;
        }        
    } else {
        return true;
    }
}

async function checkProfileVerifications(form) {
    let verifyComponents = [];
    let componentKey = '';
    let componentDefinition = {};
    if (formDataDefinition instanceof Array) {
        for (var prop in formDataDefinition) {
            if (formDataDefinition[prop] && formDataDefinition[prop].fieldVerifyFlag && formDataDefinition[prop].fieldVerifyFlag === 'Yes') {
                let verifyFieldName = formDataDefinition[prop].verifyFieldName ? formDataDefinition[prop].verifyFieldName : '';
                let fieldValue = form.submission.data[verifyFieldName];
                if (verifyFieldName != '' && fieldValue != '') {
                    componentKey = formDataDefinition[prop].key ? formDataDefinition[prop].key : '';
                    let fieldVerifyStatus = form.submission.data[componentKey];
                    if (fieldVerifyStatus != 'Yes') {
                        componentDefinition = form.getComponent(verifyFieldName);
                        verifyComponents.push(componentDefinition);
                    }
                }
            }
        }
    }
    if (verifyComponents.length) {
        let verificationErrorLabel = '';
        verifyComponents.forEach((component) => {
            if (form.submission && form.submission.data[component.key] != '') {
                verificationErrorLabel = component.t('Please verify the {{ field }}', {
                    field: component.errorLabel,
                    data: component.data
                });
                component.setCustomValidity(verificationErrorLabel);
                component.invalid = true;
                // Focus on the input field with the dynamic name attribute
                $('[name="data[' + component.key + ']"]').focus();
            }
        });
    } else {
        return true;
    }
    return false;
}

// Function to save the form data
function saveFormData(form, actionName = '') {
    // Replace this with your own implementation to save the form data
    // For example, you can make an API request to save the data
    // axios.post('your-save-endpoint', formData);
    return Formio.fetch(formSubmissionUrl, {
        body: JSON.stringify(form.submission),
        headers: {
            'content-type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'page-Number': form.page ? form.page : 0
        },
        method: 'POST',
        mode: 'cors',
    })
        .then(function (response) {
            response.json().then(function (result) {
                if (actionName == '') {
                    var successMsg = result.message ? result.message : "You will be redirected to another page.";
                    var redirectUrl = result.redirectURL ? result.redirectURL : baseUrl;
                    if (response.status == 200) {
                        if (result.success == true) {
                            Swal.fire({
                                title: result.title ? result.title : 'Redirect',
                                text: successMsg,
                                icon: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.href = redirectUrl;
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: result.title ? result.title : 'Oops...',
                                text: result.message,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false
                            }).then((result) => {
                                form.emit('submitError', '');

                                // Error occurred during submission
                                const submitButton = form.getComponent('submit');
                                if (submitButton) {
                                    submitButton.loading = false;
                                    submitButton.disabled = false;
                                    // Refresh the button's appearance to remove the loader
                                    submitButton.redraw();
                                }

                                // Reload the page
                                if (result.isConfirmed) {
                                    // Reload the page
                                    location.reload(); // or window.location.reload();
                                }
                            });
                        }
                    } else {
                        Swal.fire({ icon: 'error', title: result.title ? result.title : 'Oops...', text: 'Something went wrong!' }).then((value) => {
                            form.emit('submitError', '');
                            // Error occurred during submission
                            const submitButton = form.getComponent('submit');
                            if (submitButton) {
                                submitButton.loading = false;
                                submitButton.disabled = false;
                                // Refresh the button's appearance to remove the loader
                                submitButton.redraw();
                            }
                        });
                    }
                } else {
                }
            });
        });
}

$(function () {
    // To block the browser's copy and paste feature
    var formContainer = document.getElementById('formio');
    formContainer.addEventListener('copy', function (e) {
        e.preventDefault();
    });

    formContainer.addEventListener('paste', function (e) {
        e.preventDefault();
    });

    // To block the browser's back button and prevent users from navigating backward
    window.history.pushState(null, '', window.location.href);
    window.onpopstate = function () {
        location.reload();
        window.history.go(1);
    };

    // To block the browser's forward button and prevent users from navigating forward
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('beforeunload', function () {
        window.history.forward(1);
    });
})

function kmatLogoutEvent() {
    document.getElementById('kmat-logout-form').submit();
}